import { PageHeader } from "../../components/common";
import { Card } from "../../components/ui/card";
import { MediaLibrary } from "../../components/MediaPicker";

export default function Media() {
  return (
    <div className="space-y-6" data-testid="media-page">
      <PageHeader eyebrow="Site Yönetimi" title="Medya Kütüphanesi" subtitle="Sitede kullanılacak görseller. Yüklenen görseller otomatik küçültülür ve WebP'ye çevrilir; Site Stüdyosu'nda tek tıkla seçilir." />
      <Card className="p-5 border border-slate-200 shadow-none"><MediaLibrary /></Card>
    </div>
  );
}
